import { render, staticRenderFns } from "./NaturezasJuridicas.vue?vue&type=template&id=44afef85"
import script from "./NaturezasJuridicas.vue?vue&type=script&lang=js"
export * from "./NaturezasJuridicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports